'use strict';

(function () {
  'use strict';

  angular.module('msActivityServices').factory('trainSvc', trainSvc);

  trainSvc.$inject = ['$state', '$log', '$q', '$localStorage', 'httpSvc', 'activityFlagSvc', 'seriesSvc', 'trainStorageSvc'];

  function trainSvc($state, $log, $q, $localStorage, httpSvc, activityFlagSvc, seriesSvc, trainStorageSvc) {
    return {
      getTrain: trainStorageSvc.getTrain,
      getByStatus: trainStorageSvc.getByStatus,
      skip: skip,
      skipTo: skipTo,
      startTrain: startTrain,
      startSeries: startSeries,
      navTrain: navTrain,
      getParent: trainStorageSvc.getParent,
      setStatus: setStatus,
      createTrain: createTrain,
      containsActivity: trainStorageSvc.containsActivity,
      clearTrains: clearTrains,
      getActualCoreActivity: getActualCoreActivity
    };

    /**
     * Get the current activity in the train. This requires the train already be loaded.
     * @return {Activity} The current activity
     */
    function _getCurrentActivity() {
      return trainStorageSvc.getAllActivities().filter(function (activity) {
        return activity.responseStatus === 'CURRENT';
      })[0];
    }

    /**
     * Get the next incomplete activity
     * @return {TrainActivity} The next train activity
     */
    function _getNextIncomplete() {
      return _.find(trainStorageSvc.getAllActivities(), function (a) {
        return a.responseStatus === 'INCOMPLETE';
      });
    }

    /**
     * Get the current activity in the train - not ACTIVITY_PROGRAM and ACTIVITY_SERIES
     * @return {TrainActivity} The next train activity
     */
    function _getCurrentCoreActivity() {
      return trainStorageSvc.getAllActivities().find(function (activity) {
        return activity.type.name !== 'ACTIVITY_PROGRAM' && activity.type.name !== 'ACTIVITY_SERIES' && activity.responseStatus === 'CURRENT';
      });
    }

    /**
     * Get the next incomplete activity  - not ACTIVITY_PROGRAM and ACTIVITY_SERIES
     * @return {TrainActivity} The next train activity
     */
    function _getNextIncopleteCoreActivity() {
      return trainStorageSvc.getAllActivities().find(function (activity) {
        return activity.type.name !== 'ACTIVITY_PROGRAM' && activity.type.name !== 'ACTIVITY_SERIES' && activity.responseStatus === 'INCOMPLETE';
      });
    }

    /**
     * Get the preview Activity image
     * @return {String} Activity image link
     */
    function getActualCoreActivity() {
      var currentActivity = _getCurrentCoreActivity();
      if (currentActivity) {
        return currentActivity;
      }

      var nextIncomplete = _getNextIncopleteCoreActivity();
      if (nextIncomplete) {
        return nextIncomplete;
      }

      return null;
    }

    /**
     * Set the next incomplete activity as the current activity in the train
     * @return {Activity} The current activity
     */
    function _setCurrentActivity() {
      var nextIncomplete = _getNextIncomplete();
      if (!nextIncomplete) {
        nextIncomplete = trainStorageSvc.getNextInSeries();
      }

      if (nextIncomplete) {
        nextIncomplete.responseStatus = 'CURRENT';
      }

      return nextIncomplete;
    }

    /**
     * Load the train from the server and nav to the first item
     */
    function startTrain(activityRouter) {
      return trainStorageSvc.fetchTrain().then(function () {
        return navTrain(activityRouter);
      });
    }

    /**
     * Navigate to the next item in the train
     */
    function navTrain(activityRouter) {
      var currentActivity = _getCurrentActivity();
      if (!currentActivity) {
        // no activity is marked as the current one - we need to promote something
        // get the next activity marked as INCOMPLETE
        var nextIncomplete = _setCurrentActivity();
        if (nextIncomplete) {
          _navType(nextIncomplete, activityRouter);
        } else {
          // recommended trains should always go to the complete screen
          // If there's no dest for some reason, go there too (this should probably not happen)
          if (!$localStorage.train.dest || $localStorage.train.type === 'recommended') {
            activityRouter.completeTrain();
          } else {
            // if the train has a specific returning destination, go there
            try {
              $localStorage.train.dest.navigateFn($localStorage.train.dest.params);
            }
            // If the train does not have a return destination, or the state cannot be
            // resolved from the current context, just go to the default.
            catch (e) {
              $log.warn(e, $state.current.name, $localStorage.train.dest);
              activityRouter.navigateDefault();
            }
          }
        }
      } else {
        _navType(currentActivity, activityRouter);
      }
      return currentActivity;
    }
    /**
     * Nav to the correct page based on the activity type
     */
    function _navType(activity, activityRouter) {
      if (activity.type.name === 'CORE_ARTICLE') {
        activityRouter.nextSection({
          url: activity.url
        });
      } else if (activity.type.normal) {
        activityRouter.navigateIntro({
          url: activity.url
        });
      } else if (activity.type.name === 'CORE_INSPIRATION') {
        activityRouter.navigateInspiration({
          url: activity.url
        });
      } else if (activity.type.name === 'ACTIVITY_PROGRAM') {
        activityRouter.navigateProgram({
          id: activity.id
        });
      } else if (activity.type.name === 'ACTIVITY_SERIES') {
        startSeries(activity, activityRouter);
      } else {
        $log.debug('Unaccounted for activity type in train: ', activity.type);
        // Eh let's just send them to the intro page and see what happens
        activityRouter.navigateIntro({
          url: activity.url
        });
      }
    }

    /**
     * Create a "fake" train that contains a set list of activities.
     * This is not stored in the database, but is stored in localstorage until the context switches back to the database train.
     * You can also control the destination of this train after completion by passing a destination
     *
     * @param  {List} activities A list of activities to create the fake train with. This can contain series and programs as well
     * @param  {Object} dest     This defines where the train should go after completion. If left blank, this will return to the current state
     */
    function createTrain(activityRouter, activities, dest, noNav) {
      if (!angular.isArray(activities)) {
        activities = [activities];
      }
      var promises = [];
      activities.forEach(function (activity) {
        activity.responseStatus = 'INCOMPLETE';
        if (activity.type.name === 'ACTIVITY_SERIES') {
          promises.push(seriesSvc.getSeriesActivities(activity).then(function (res) {
            activity.activities = res;
          }));
        }
      });
      // create a temp train out of a set of activities
      $localStorage.train = {
        activities: activities,
        type: 'local'
      };
      // if there's a destination override, use it - otherwise, use current state
      if (dest) {
        $localStorage.train.dest = dest;
      }
      if (!noNav) {
        $q.all(promises).then(function () {
          navTrain(activityRouter);
        });
      }
    }
    /**
     * Set the train status of an activity in local storage. Back-end is updated separately. 
     * @param {Activity} activity  The activity (not necessarily a train activity) to set the train status of
     * @param {responseStatus} status The status to set
     */
    function setStatus(activity, status) {
      var trainActivity = trainStorageSvc.getTrainActivity(activity);
      trainActivity.responseStatus = status;

      if (status === 'SKIPPED' && angular.isArray(trainActivity.activities)) {
        // Skip all the child activities as well
        trainActivity.activities.forEach(function (a) {
          a.responseStatus = status;
        });
      }

      //mark series complete if applicable
      trainStorageSvc.checkSeriesStatus();
    }

    /**
     * Indicate that the user has decided to start a series
     * @param  {Series} series The series to start
     */
    function startSeries(series, activityRouter) {
      var nextActivity = _getNextIncomplete();
      if (!nextActivity) {
        //every activity has been completed or skipped already so take the first
        nextActivity = series.activities[0];
        series.current = 0;
      }
      nextActivity.responseStatus = 'CURRENT';

      _navType(nextActivity, activityRouter);
    }
    /**
     * Skip indicates that a user doesn't want to do this activity now, but may want it later.
     *
     * @param  {Activity} activity The activity to skip
     * @param  {Boolean} hide      Set to true if we should hide instead of skip
     */
    function skip(activity, hide, reason, activityRouter) {
      setStatus(activity, 'SKIPPED');
      activityFlagSvc.skip(activity, hide, reason).then(function () {
        return navTrain(activityRouter);
      });
    }
    /**
     * Skip all the activities between the current activity and the one passed in.
     * This is currently not wired up until we get a confirmation from Joslin
     */
    function skipTo(activity, activityRouter) {
      var toSkip = [];
      for (var i = 0; i < $localStorage.train.activities.length; i++) {
        var a = $localStorage.train.activities[i];
        if (a.id === activity.id) {
          break;
        }
        if (a.responseStatus === 'INCOMPLETE' || a.responseStatus === 'CURRENT') {
          toSkip.push(a);
        }
      }
      toSkip.forEach(function (a) {
        skip(a);
      });
      setStatus(activity, 'CURRENT').then(function () {
        navTrain(activityRouter);
      });
    }

    function clearTrains() {
      httpSvc.delete('/apiproxy/user/activities/train');
    }
  }
})();